import {
  ArtistIntroCard,
  AnnouncementModal,
  AccordionGroup,
  ButtonGroup,
  CardOverlay,
  CardFullWidth,
  Calendar,
  ShowsCalendar,
  Carousel,
  FlexBox,
  StickyDisclaimer,
  Disclaimer,
  EdpFullScreenVideo,
  Footer,
  Gallery,
  NavigationHeader,
  Hero,
  InteractiveOverlayCard,
  HeroEDPHeaderV2,
  RulesCard,
  JumpLinkGroup,
  FormModule,
  HeroEdpHeader,
  HeroV2,
  HeroGeneralInfo,
  IframeVideo,
  InfoBar,
  InfoBarSection,
  NotificationBanner,
  TileCarousel,
  LostandFound,
  GroupVotingButton,
  CohortVotingButton,
  CardRow,
  IconButtonsCard,
  SignUp
} from '~modules'
import {
  Accordion,
  Button,
  Card,
  CardMedia,
  CarouselSlide,
  Divider,
  Form,
  Heading,
  ImageLink,
  Leaderboard,
  Module,
  Modal,
  Paragraph,
  Pill,
  Vimeo,
  PlayButton,
  PauseButton,
  GroupTicketingCard,
  DoesNotExist
} from '~elements'

export const components = {
  ArtistIntroCard,
  AnnouncementModal,
  Accordion,
  AccordionGroup,
  Button,
  ButtonGroup,
  Card,
  CardOverlay,
  CardRow,
  Calendar,
  ShowsCalendar,
  CardFullWidth,
  FlexBox,
  CardMedia,
  Carousel,
  CarouselSlide,
  Divider,
  StickyDisclaimer,
  Disclaimer,
  EdpFullScreenVideo,
  Footer,
  Form,
  FormModule,
  Gallery,
  NavigationHeader,
  Heading,
  TileCarousel,
  Hero,
  HeroV2,
  HeroEdpHeader,
  HeroGeneralInfo,
  IframeVideo,
  InfoBar,
  InfoBarSection,
  InteractiveOverlayCard,
  HeroEDPHeaderV2,
  NotificationBanner,
  ImageLink,
  JumpLinkGroup,
  Leaderboard,
  LostandFound,
  Module,
  Modal,
  Paragraph,
  Pill,
  Vimeo,
  RulesCard,
  PlayButton,
  PauseButton,
  GroupVotingButton,
  CohortVotingButton,
  IconButtonsCard,
  GroupTicketingCard,
  SignUp,
  DoesNotExist
}
